import * as React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowTrendDown,
  faArrowTrendUp,
} from '@fortawesome/pro-solid-svg-icons';
// @ts-ignore
import styles from './PriceTrend.module.scss?module';

interface PriceTrendProps {
  /** 'up' or 'down' as the price change endpoint sends it; anything else
      renders nothing. */
  trend: string | null | undefined;
  /** The amount in percent, always positive (the direction is the trend);
      null while the ERP does not send it. */
  percent: number | null | undefined;
  className?: string;
}

/* The direction and size of a price change, on the dashboard's "Info overview"
   and the price changes page (Marketing 28.10.2026): trend arrow and whole
   percent, signed by the trend. A decrease is green, an increase stays in the
   text colour: in a change list the colour states the direction, not the
   advantage; red stays reserved for the promotion advantage in Deals and on
   strike-through prices (Marketing 04.11.2026, P-5094). Arrow and sign carry
   the direction too, so colour is never the only signal, and screen readers
   get a sentence instead of the icon. */
export default function PriceTrend({
  trend,
  percent,
  className,
}: PriceTrendProps) {
  if (trend !== 'up' && trend !== 'down') {
    return null;
  }
  const isUp = trend === 'up';
  const amount = percent != null ? Math.round(Math.abs(percent)) : null;

  return (
    <span className={clsx(isUp ? styles.up : styles.down, className)}>
      <FontAwesomeIcon
        icon={isUp ? faArrowTrendUp : faArrowTrendDown}
        aria-hidden
      />
      {amount != null && (
        <span aria-hidden>{` ${isUp ? '+' : '−'}${amount}%`}</span>
      )}
      <span className="visually-hidden">
        {`Price ${isUp ? 'up' : 'down'}${
          amount != null ? ` by ${amount}%` : ''
        }`}
      </span>
    </span>
  );
}
